"use client";

import { MultiSelect } from "@leabankab/component-library";
import { FormField } from "@leabankab/component-library/react-hook-form";
import { useConstantSelectOptions } from "@/features/customer-information/hooks/use-constant-options";

interface ConstantMultiSelectProps {
	name: string;
	label: string;
	/** Loads options from `constants.<optionsKey>.options`. */
	optionsKey: string;
	min?: number;
	max?: number;
}

/**
 * Multi-select bound to the surrounding RHF form, with options sourced from a
 * `constants.<optionsKey>` translation namespace.
 */
export const ConstantMultiSelect = ({
	name,
	label,
	optionsKey,
	min,
	max,
}: ConstantMultiSelectProps) => {
	const options = useConstantSelectOptions(optionsKey);

	return (
		<FormField
			name={name}
			render={({ field }) => (
				<MultiSelect
					label={label}
					options={options}
					min={min}
					max={max}
					{...field}
					value={field.value ?? []}
				/>
			)}
		/>
	);
};
